import { NumberSettingCard } from "../components/NumberSettingCard";
import { SettingCard } from "../components/SettingCard";
import { VoicesManager } from "../components/VoicesManager";
import { settingsService } from "../services/settingsService";
import type { SettingsTabProps } from "./settingsTabTypes";

export const VoiceSettingsTab = ({ settings, onSettingsChange }: SettingsTabProps) => {
  const handleUpdateVoiceConversationsPerWeek = async (value: number) => {
    await settingsService.updateVoiceConversationsPerWeek(value);
    onSettingsChange({ voiceConversationsPerWeek: value });
  };

  const handleUpdateVoiceMinutesPerWeek = async (value: number) => {
    await settingsService.updateVoiceMinutesPerWeek(value);
    onSettingsChange({ voiceMinutesPerWeek: value });
  };

  const handleUpdateMaxVoiceCallMinutes = async (value: number) => {
    await settingsService.updateMaxVoiceCallMinutes(value);
    onSettingsChange({ maxVoiceCallMinutes: value });
  };

  const handleUpdateSttSessionsPerWeek = async (value: number) => {
    await settingsService.updateSttSessionsPerWeek(value);
    onSettingsChange({ sttSessionsPerWeek: value });
  };

  return (
    <>
      <SettingCard>
        <VoicesManager />
      </SettingCard>
      <NumberSettingCard
        title="Voice Conversations Per Week"
        description="Voice mode calls a Pro user can start per week. Calls shorter than 10 seconds do not count. Applies to all users."
        value={settings.voiceConversationsPerWeek}
        onSave={handleUpdateVoiceConversationsPerWeek}
      />
      <NumberSettingCard
        title="Voice Minutes Per Week"
        description="Voice mode minutes a Pro user can use per week (120 = 2 hours). Checked when a call starts, so the last call can go over. Applies to all users."
        value={settings.voiceMinutesPerWeek}
        onSave={handleUpdateVoiceMinutesPerWeek}
      />
      <NumberSettingCard
        title="Max Voice Call Length (minutes)"
        description="Safety limit for one voice mode call. When a call reaches this length, the voice agent ends it immediately (also mid-sentence), disconnects the app, and the app shows a 'time limit reached' message. Purpose: stop a bug or an app that stays connected (for example a phone left in a pocket with the call open) from keeping a call open for hours, which costs money for every minute. A call ends earlier if the user has fewer weekly voice minutes left, but each call gets at least 1 minute. Applies to all users from their next call; calls already open keep the limit they started with."
        value={settings.maxVoiceCallMinutes}
        onSave={handleUpdateMaxVoiceCallMinutes}
      />
      <NumberSettingCard
        title="Dictation Sessions Per Week"
        description="Speech-to-text sessions a Pro user can start per week. Applies to all users."
        value={settings.sttSessionsPerWeek}
        onSave={handleUpdateSttSessionsPerWeek}
      />
    </>
  );
};
